export default "__VITE_PUBLIC_ASSET__14f22780__"